export default {
  "content": "<path fill=\"#FFF\" stroke=\"#8686FD\" stroke-width=\"3\" stroke-miterlimit=\"10\" d=\"M27.3 1.5C13 1.5 1.5 12.9 1.5 26.9c0 22.6 25.8 44.7 25.8 44.7S53 49.1 53 26.9c.1-14-11.5-25.4-25.7-25.4z\"/><g fill=\"none\" stroke=\"#1A0E54\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\"><path d=\"M27.4 17.8l-16.9 7.4 16.9 7.4L44 25.2zM35.8 37.2v2.7c0 3.1-3.8 5.5-8.6 5.5s-8.6-2.4-8.6-5.5v-2.7\"/></g><path fill=\"none\" stroke=\"#1A0E54\" stroke-width=\"3\" stroke-miterlimit=\"10\" d=\"M27.3 3.7C14.2 3.7 3.7 14.1 3.7 27c0 20.7 23.5 40.8 23.5 40.8S50.8 47.2 50.8 27c.1-12.9-10.5-23.3-23.5-23.3z\"/>",
  "attrs": {
    "version": "1.2",
    "baseProfile": "tiny",
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 54.5 73.6",
    "overflow": "visible"
  }
};